import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { error } from '@/utils/logger';
import { isNativePlatform } from '@/lib/platform';
import { WebAnalytics } from '@/lib/analytics';
import {
  EVENT_APP_OPENED,
  EVENT_APP_BACKGROUNDED,
  EVENT_APP_RESUMED,
} from '@/lib/analyticsEvents';

/**
 * Tracks native app lifecycle events (open, background, resume) via Mixpanel.
 * No-op on web. Call once near the app root (e.g. RootLayout).
 */
export function useNativeAppLifecycle(): void {
  useEffect(() => {
    if (!isNativePlatform()) return;

    // Cold start / foreground launch.
    WebAnalytics.track(EVENT_APP_OPENED);

    const listenerPromise = App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) {
        WebAnalytics.track(EVENT_APP_RESUMED);
      } else {
        WebAnalytics.track(EVENT_APP_BACKGROUNDED);
      }
    });

    return () => {
      void listenerPromise.then((handle) => handle.remove()).catch((e) => {
        error('[useNativeAppLifecycle] Failed to remove appStateChange listener', e);
      });
    };
  }, []);
}
